import { Component } from '@angular/core';
import { Subject } from 'rxjs';
import { LoadingPageService } from './loading-page.service';

@Component({
  selector: 'loading-page',
  templateUrl: './loading-page.component.html',
  styleUrls: ['./loading-page.component.css']
})
export class LoadingPageComponent {
  isLoading: Subject<boolean> = this.loaderService.isLoading;
  constructor(private loaderService: LoadingPageService) { }
}
